import React from 'react';
import { Box, Title, Group, Text, Image, Button } from '@mantine/core';
import { Link } from '@inertiajs/react'; // Changed from 'react-router-dom' to '@inertiajs/react'

interface Author {
  id: number;
  name: string;
  avatar_url?: string;
  bio?: string;
  claimed_artist?: {
    id: number;
    name: string;
    slug: string;
    has_stripe_account?: boolean;
  };
}

interface AboutAuthorProps {
  post?: {
    author: Author;
  };
  author?: Author;
  stripePublishableKey?: string;
  isUserSignedIn?: boolean;
  mb?: string | number;
}

const AboutAuthor: React.FC<AboutAuthorProps> = ({
  post,
  author: directAuthor,
  stripePublishableKey,
  isUserSignedIn = true,
  mb,
}) => {
  // Use either the direct author prop or get it from the post
  const author = directAuthor || post?.author;

  // If we don't have an author object at all, return null
  if (!author) {
    return null;
  }

  const handleSupportClick = () => {
    // Implement the stripe payment functionality here
    console.log('Support button clicked with key:', stripePublishableKey);
  };

  return (
    <Box
      className="p-3 rounded shadow-sm mb-4"
      style={(theme) => ({
        backgroundColor: '#17171790',
        borderRadius: theme.radius.sm,
        padding: theme.spacing.md,
        marginBottom: mb || theme.spacing.md,
        boxShadow: theme.shadows.sm,
      })}
    >
      <Title size="lg" fw="bold" className="poppins text-white">
        About the Author
      </Title>

      <Group my="md" align="flex-start">
        {/* Use Inertia Link instead of React Router Link */}
        <Link href={`/bloggers/${author.name}`} style={{ textDecoration: 'none' }}>
          {author.avatar_url ? (
            <Image src={author.avatar_url} radius="md" style={{ width: '60px' }} alt={`${author.name}'s avatar`} />
          ) : (
            <Image src="https://dancewise.s3.amazonaws.com/WCWD+blank+profile2.png" radius="md" alt="Default avatar" />
          )}
        </Link>

        <Box>
          {/* Use Inertia Link instead of React Router Link */}
          <Link href={`/bloggers/${author.name}`} style={{ textDecoration: 'none', color: 'black' }}>
            <Text fw="bold" size="md" className="poppins text-white">
              {author.name}
            </Text>
          </Link>
          <Text size="xs" c="dimmed">
            {author.bio || "This user hasn't written a bio yet."}
          </Text>
        </Box>
      </Group>

      {/* Support Button - Only shown if the author's claimed artist has a Stripe account */}
      {author.claimed_artist?.has_stripe_account && (
        <Box>
          <Button
            variant="outline"
            onClick={handleSupportClick}
            leftSection={<Image src="/images/money-star-icon.png" width={20} height={20} alt="Support icon" />}
            data-stripe-public-key={stripePublishableKey}
            className="support-image-button"
            id="support-trigger"
          >
            Support
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default AboutAuthor;
